export default {
    "modal": {
        "login": {
            "title": "Anmeldung",
            "userName": "Benutzername",
            "password": "Passwort",
            "singleSignOn": "Einmalanmeldung (Single sign-on)",
            "signInWith": "Anmelden mit..."
        }
    }
};
